import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ContextMenuButtonComponent } from './context-menu-button.component';
import { ContextMenuContainerComponent } from './context-menu-container.component';
import {
  ContextMenuComponent,
  ContextMenuItemDirective,
} from './context-menu.component';

@NgModule({
  declarations: [
    ContextMenuComponent,
    ContextMenuButtonComponent,
    ContextMenuContainerComponent,
    ContextMenuItemDirective,
  ],
  imports: [CommonModule, OverlayModule, PortalModule],
  exports: [
    ContextMenuComponent,
    ContextMenuButtonComponent,
    ContextMenuContainerComponent,
    ContextMenuItemDirective,
  ],
})
export class ContextMenuModule {}
